import { Alert, Box, Stack, Typography, useTheme } from '@mui/material';
import { FormEventHandler, PropsWithChildren } from 'react';

import { Icon } from '@/components/Icon/Icon';
import { FullPageLoaderOverlay } from '@/components/Layout/FullPageLoader';

import { useTranslate } from '@/hooks/useTranslate';

import { getAPIErrorMessage } from '@/utils/api';

import { ProtectedImg } from '../QuestionsDrawer/QuestionDrawer.styled';

type TaxInfoQuestionFormProps = {
  index: number;
  total: number;
  sectionTitle: string;
  answerError?: Error | null;
  isLoading?: boolean;
  onSubmit?: FormEventHandler<HTMLFormElement>;
} & PropsWithChildren;

export function TaxInfoQuestionForm({
  index,
  total,
  sectionTitle,
  answerError,
  isLoading,
  onSubmit,
  children,
}: TaxInfoQuestionFormProps) {
  const { t } = useTranslate();
  const theme = useTheme();

  return (
    <>
      <ProtectedImg />
      {answerError && (
        <Alert icon={<Icon name="alert" />} color="error" variant="standard">
          {getAPIErrorMessage(answerError)}
        </Alert>
      )}
      <Box alignSelf="stretch" component="form" onSubmit={onSubmit}>
        <Typography
          variant="body1"
          color={theme.palette.text.secondary}
          textAlign="center"
          mb={1}
        >
          {t('questionDrawer.questionForm.formBody', { no: index + 1, total })}
        </Typography>
        <Typography variant="h4" textAlign="center" mb={2}>
          {sectionTitle}
        </Typography>
        <Stack direction="column" alignItems="stretch">
          {children}
        </Stack>
      </Box>
      {isLoading && <FullPageLoaderOverlay />}
    </>
  );
}
